"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.historyToHistoryElements = void 0;
function historyToHistoryElements(history, firstUnread) {
    var roomElements = historyToElements(history);
    roomElements = addTimePassed(roomElements);
    roomElements = addUnreadMarker(roomElements, firstUnread);
    return roomElements;
}
exports.historyToHistoryElements = historyToHistoryElements;
function historyToElements(roomHistory) {
    var previousAuthorHash;
    var previousTs;
    var previousHasEdits = false;
    return roomHistory.map(function (message) {
        var _a = message.author_user, authorUserId = _a.id, authorName = _a.name, authorIsBot = _a.is_bot, authorAvatarUrl = _a.avatar_url, deleted = message.deleted, version = message.version;
        // if messages were posted after 15 minutes show timestamp and avatar
        var longPause = (message.ts && previousTs && message.ts - previousTs > 15 * 60 * 1000 * 1000) || false;
        previousTs = message.ts;
        var authorHash = authorUserId + "-" + authorName + "-" + authorIsBot + "-" + authorAvatarUrl;
        var authorChanged = authorHash !== previousAuthorHash;
        previousAuthorHash = authorHash;
        var hasEdits = (deleted || (version && version > 1)) === true;
        var needsAvatar = authorChanged || longPause || hasEdits || previousHasEdits;
        previousHasEdits = hasEdits;
        return {
            id: message.id,
            kind: "message",
            message: message,
            needsAvatar: needsAvatar,
        };
    });
}
function addTimePassed(roomElements) {
    var cutoffTs = 0.5 * 3600 * 1000 * 1000;
    var lastTs = 0;
    var output = roomElements.clear();
    roomElements.map(function (element) {
        if ("message" === element.kind) {
            var _a = element.message, id = _a.id, ts = _a.ts;
            if (lastTs && ts - lastTs > cutoffTs) {
                output = output.push({
                    id: "time-passed-" + id,
                    kind: "time_passed",
                    timePassed: { ts: ts, lastTs: lastTs },
                });
            }
            lastTs = ts;
            output = output.push(element);
        }
    });
    output = output.push({
        id: "time-passed-last",
        kind: "time_passed_last",
        timePassedLast: { lastTs: lastTs, showAfterTs: lastTs ? cutoffTs + lastTs : undefined },
    });
    return output;
}
function addUnreadMarker(roomElements, firstUnread) {
    if (firstUnread) {
        var unreadTs_1 = firstUnread.ts;
        var index = roomElements.findIndex(function (element) {
            return element.kind === "message" ? element.message.ts === unreadTs_1 : false;
        });
        if (index !== -1) {
            var count = roomElements.count(function (element) { return (element.kind === "message" && element.message.unseen) || false; });
            var firstUnread_1 = {
                id: "unread",
                kind: "first_unread",
                isOld: count === 0,
            };
            var nextRoomElements = roomElements.insert(index, firstUnread_1);
            // On Android, there's a bug: `List.insert(index, el)` inserts `[el]` instead of just `el`
            if (firstUnread_1 !== nextRoomElements.get(index)) {
                nextRoomElements = nextRoomElements.set(index, firstUnread_1);
            }
            return nextRoomElements;
        }
    }
    return roomElements;
}
